import Localize from 'react-intl-universal';

import { getDuration } from '../../Util.jsx';

export const getSessionDuration = (session) => {
  const diff = getDuration(session?.duration);
  let displayString = '';
  if (diff.dayDiff && diff.dayDiff >= 1) {
    displayString += diff.dayDiff + ' ';
    if (diff.dayDiff === 1) {
      displayString += Localize.get('EventDetails.day');
    } else {
      displayString += Localize.get('EventDetails.days');
    }
  }

  if (diff.hourDiff && diff.hourDiff >= 1) {
    if (displayString.length > 0) {
      displayString += ', ';
    }

    displayString += diff.hourDiff + ' ';
    if (diff.hourDiff === 1) {
      displayString += Localize.get('EventDetails.hour');
    } else {
      displayString += Localize.get('EventDetails.hours');
    }
  }

  if (diff.minDiff && diff.minDiff >= 1) {
    if (displayString.length > 0) {
      displayString += ', ';
    }

    displayString += diff.minDiff + ' ' + Localize.get('EventDetails.minutes');
  }

  return displayString;
};
